import { kebabify } from '@toasttab/shared/src/utils/stringUtils'
import { getHasAnalyticsConsent } from '../src/utils/consentUtils'

const heapAnalytics = (heapObject: object) => {
  if (typeof window === 'undefined') return

  const hasAnalyticsConsent = getHasAnalyticsConsent()
  if (!hasAnalyticsConsent) {
    return
  }

  let attempts = 0
  const maxAttempts = 10

  const waitForHeap = () => {
    if (window.heap && window.heap.loaded) {
      window.heap.addEventProperties(heapObject)
      window.heap.addUserProperties(heapObject)
      window.heap.track('Heap Analytics Initialized', heapObject) // Optional event name
    } else if (attempts++ < maxAttempts) {
      setTimeout(waitForHeap, 500)
    } else {
      console.warn('Heap not ready after multiple attempts.')
    }
  }

  waitForHeap()
}

export type TrackEventProps = {
  name: string
  properties?: Record<string, string | number | boolean | undefined>
}

export const trackEvent = ({
  name,
  properties,
  trackingPrefix
}: TrackEventProps & { trackingPrefix: string }) => {
  if (typeof window === 'undefined') {
    return
  }

  if (!getHasAnalyticsConsent()) {
    return
  }

  if (typeof window.heap?.track !== 'function') {
    return
  }

  window.heap.track(`${trackingPrefix}-${kebabify(name)}`, properties)
}

export default heapAnalytics
